export default __webpack_public_path__ + "static/media/sign up farmer1.c0055ab2.png";